export const normalizeString = (value?: string | null): string => (value || '').toLowerCase();
